import { logger } from '../../../utils/logger'
import {
  fetchProgramDesignations,
  toSearchSelectOptions,
} from '../../Block/donation/useFetchProgramDesignations'
import type { ServiceHandler } from './service-registry'

/**
 * GET_PROGRAM_DESIGNATIONS service handler
 *
 * Handles requests to retrieve program designations for the current campaign.
 * Supports pagination via the page parameter.
 *
 * Expected payload: { page?: number|string }
 * Expected response format:
 * - Success: { designations: SearchSelectOption[], pagination: PaginationMetadata }
 * - Error: "error message"
 */
export const getProgramDesignations: ServiceHandler = async ({
  iframeId,
  messageId,
  payload,
  sendSuccessResponse,
  sendErrorResponse,
  pageConfig,
}) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:getProgramDesignations: Campaign ID not available')
    }

    // TODO: CL-51093 improve payload validation with Yup/Zod library
    if (!payload || typeof payload !== 'object') {
      sendErrorResponse(iframeId, messageId, 'Payload is expected to be an object')
      return
    }

    const { page: pageParam } = payload as { page?: unknown } // TODO: CL-51093 improve typing
    const page = pageParam ? Number(pageParam) : 1 // TODO: CL-51093 improve validation

    const { designations: rawDesignations, pagination } = await fetchProgramDesignations({
      campaignId,
      searchString: '',
      page,
    })

    const designations = toSearchSelectOptions(rawDesignations)

    logger(
      'info',
      'CustomEmbeddedCode:getProgramDesignations: Program designations fetched successfully',
      {
        context: { iframeId, messageId, campaignId, page },
      },
    )

    sendSuccessResponse(iframeId, messageId, {
      designations,
      pagination,
    })
  } catch (error) {
    logger(
      'error',
      new Error('CustomEmbeddedCode:getProgramDesignations: Failed to fetch program designations', {
        cause: error,
      }),
      {
        context: { iframeId, messageId, campaignId },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to fetch program designations')
  }
}
